import React, {PureComponent} from 'react';
import {Switch, FormGroup, Tooltip} from 'xsolla-uikit';

class SwitchExample extends PureComponent {
  constructor(props) {
    super(props)
    this.props = props;
    this.handleToggle = props.handleToggle ? props.handleToggle : null;
    this.title = props.title ? props.title : null;
    this.label = props.label ? props.label : null;
    this.tooltip = props.tooltip ? props.tooltip : null;
    this.state = {
      fetching: this.props['fetching'] || false,
      value: this.props['value'] || false
    }
  }


  toggleFetching = () => {
    this.handleToggle && this.handleToggle(!this.state.fetching)
    this.setState({ fetching: !this.state.fetching })
  };

  toggleValue = () => {
    this.handleToggle && this.handleToggle(!this.state.value)
    this.setState({ value: !this.state.value })
  };

  toggleValueDelay = () => {
    this.toggleFetching();
    setTimeout(() => {
      this.toggleValue();
      this.toggleFetching();
    }, 700);

    this.handleToggle && this.handleToggle(this.state.value)
  };

  render() {
    // props.title = props.title || null;
    // props.label = props.label || null;
    return (
      <div>
        <FormGroup label={this.title} indentation="lg">
        <FormGroup indentation="xs">
          <div style={{display: 'flex', alignItems:'center'}}>

          <Switch
            name="switch_1"
            label={this.label}
            tooltip={this.tooltip}
            input={{
              value: this.state.value,
              onChange: this.toggleValue
            }}
          />
            {this.props.customLabel}
            {this.props.customLabel &&
              <div style={{marginLeft: 4}}>
              <Tooltip
                distance={12}
                label="Enables everything, but not real"
                />
                </div>
            }
            </div>
            </FormGroup>
          <FormGroup indentation="sm">
            <div className="keys-management-form--switch-description" style={{marginLeft: 82}}>{this.props.children}</div>
            </FormGroup>
        </FormGroup>

        {/* <FormGroup label="Disabled" indentation="lg">
          <Switch
            name="switch_2"
            input={{
              value: this.state.value,
              onChange: this.toggleValue
            }}
            label="Disabled label"
            disabled={true}
          />
        </FormGroup>

        <FormGroup label="Fetching" indentation="lg">
          <Switch
            name="switch_3"
            input={{
              value: this.state.value,
              onChange: this.toggleValueDelay
            }}
            label="Локализованый свитчер"
            tooltip="Tooltip message"
            tooltipInteractive={true}
            offLabel="Выкл"
            onLabel="Вкл"
            fetching={this.state.fetching}
          />
        </FormGroup>

        <FormGroup label="With error" indentation="lg">
          <Switch
            label="With error"
            input={{
              value: this.state.value,
              onChange: this.toggleValue
            }}
            meta={{
              touched: true,
              error: 'Error message'
            }}
          />
        </FormGroup> */}
      </div>
    );
  }
}

export default SwitchExample;
